export { default } from './StarExperience'
